import { ThemingContext, InlineChildren, Icon, Text, Theming } from '@doordash/design-language';
import { buttonOverridesFromTheme, TOAST_CONTENT_PROPTYPES } from '../constants.js';
import { ToastContainer, ToastContentContainer } from '../styles.js';
import Button from '@doordash/component-button';
import Loading from '@doordash/component-loading';
import React from 'react';

var ToastContent = function ToastContent(_ref) {
  var text = _ref.text,
      icon = _ref.icon,
      isLoading = _ref.isLoading,
      action = _ref.action,
      position = _ref.position,
      insetFromEdge = _ref.insetFromEdge;
  var theme = React.useContext(ThemingContext);
  var hasAction = typeof action !== 'undefined' && typeof action.text !== 'undefined' && typeof action.onClick === 'function';
  return /*#__PURE__*/React.createElement(ToastContainer, {
    insetFromEdge: insetFromEdge,
    position: position
  }, /*#__PURE__*/React.createElement(ToastContentContainer, {
    role: "alert",
    "aria-live": "off",
    hasAction: hasAction
  }, /*#__PURE__*/React.createElement(InlineChildren, {
    alignItems: InlineChildren.Alignment.Center,
    justifyContent: InlineChildren.Justification.SpaceBetween
  }, /*#__PURE__*/React.createElement(InlineChildren, {
    alignItems: InlineChildren.Alignment.Center
  }, icon && !isLoading && /*#__PURE__*/React.createElement(Icon, {
    type: icon,
    color: Text.Colors.ToastInformationalForeground
  }), isLoading && /*#__PURE__*/React.createElement(Loading, {
    color: Loading.Colors.ToastInformationalForeground,
    size: Loading.Sizes.Small
  }), /*#__PURE__*/React.createElement(Text, {
    styles: Text.Styles.ToastBody,
    color: Text.Colors.ToastInformationalForeground
  }, text)), hasAction && /*#__PURE__*/React.createElement(Theming, {
    overrides: buttonOverridesFromTheme(theme)
  }, /*#__PURE__*/React.createElement(Button, {
    isInline: true,
    type: Button.Types.FlatPrimary,
    onClick: action.onClick,
    padding: Button.Padding.None
  }, /*#__PURE__*/React.createElement(Text, {
    color: Text.Colors.ButtonFlatPrimaryForeground,
    styles: Text.Styles.ToastAction
  }, action.text))))));
};

ToastContent.propTypes = TOAST_CONTENT_PROPTYPES;
ToastContent.defaultProps = {};

export { ToastContent as default };
